<template>
    <div class="initial-landing-module">
        <DashboardLayoutComponent
            @on-set-current-sidebar="onSetCurrentSidebar($event)"
        >
            <div v-if="!accessAllNav" class="initial-landing section-metric">
                <div class="initial-landing__wrapper">
                    <ViewListIcon class="initial-landing__icon" />
                    <span class="initial-landing__title">
                        Search By
                    </span>
                </div>
                <div v-if="showBackButton" class="initial-landing__back-btn">
                    <ButtonComponent
                        v-bind="goBackBtnProps"
                        @click="--sectionLevelSelected"
                    >
                        <template v-slot:prepend>
                            <ArrowLeftIcon aria-hidden="true" />
                        </template>
                    </ButtonComponent>
                </div>
                <template v-if="menuNav.current == 'Therapeutic Class'">
                    <template v-for="(level, index) in arr" :key="index">
                        <SectionListComponent
                            v-if="showList(index)"
                            v-bind="sectionProps(level)"
                            :section-id="sectionId"
                            class="initial-landing__list"
                            @section_clicked="onSectionClicked($event, level)"
                            @set_sections="onSetSections(level)"
                            @update_section_id="updateSectionId($event)"
                        />
                        <template
                            v-if="
                                !sectionLevelSelected ||
                                    (level === 2 && sectionLevelSelected !== 2)
                            "
                        >
                            <template v-for="(i, o) in 3 - _.size(arr)" :key="o">
                                <EmptyStateComponent
                                    v-if="!isTablet"
                                    class="initial-landing__list"
                                    v-bind="emptyStateProps"
                                />
                            </template>
                        </template>
                    </template>
                </template>
            </div>
            <!-- user metric level 5 -->
            <div v-else-if="!isLoading" class="initial-landing">
                <div class="initial-landing__wrapper">
                    <ViewListIcon class="initial-landing__icon" />
                    <span class="initial-landing__title">
                        Search By
                    </span>
                </div>
                <div v-if="showBackButton" class="initial-landing__back-btn">
                    <ButtonComponent
                        v-bind="goBackBtnProps"
                        @click="--sectionLevelSelected"
                    >
                        <template v-slot:prepend>
                            <ArrowLeftIcon aria-hidden="true" />
                        </template>
                    </ButtonComponent>
                </div>
                <NavbarComponent
                    :metric-level="userMetricLevel"
                    :nav-selected="menuNav.current"
                    @nav_changed="onMenuNavTypeChange($event, item)"
                />
                <template v-if="menuNav.current == 'Therapeutic Class'">
                    <template v-for="(level, index) in arr" :key="index">
                        <SectionListComponent
                            v-if="showList(index)"
                            v-bind="sectionProps(level)"
                            :section-id="sectionId"
                            class="initial-landing__list"
                            @section_clicked="onSectionClicked($event, level)"
                            @set_sections="onSetSections(level)"
                            @update_section_id="updateSectionId($event)"
                        />
                        <template
                            v-if="
                                !sectionLevelSelected ||
                                    (level === 2 && sectionLevelSelected !== 2)
                            "
                        >
                            <template v-for="(i, o) in 3 - _.size(arr)" :key="o">
                                <EmptyStateComponent
                                    v-if="!isTablet"
                                    class="initial-landing__list"
                                    v-bind="emptyStateProps"
                                />
                            </template>
                        </template>
                    </template>
                </template>
                <template v-if="menuNav.current == 'Indications' && accessAllNav">
                    <DiseaseListComponent
                        @set_diseases="menuNavRedirect($event.value, {type: menuNav.current, selectedLetter: $event.selectedLetter})"
                    />
                </template>
                <template v-if="menuNav.current == 'Specialties' && accessAllNav">
                    <SpecialtyListComponent
                        @set_specialties="menuNavRedirect($event, {type: menuNav.current})"
                    />
                </template>
                <template v-if="menuNav.current == 'Brands' && accessAllNav">
                    <BrandListComponent
                        @set_brands="menuNavRedirect($event.value, {type: menuNav.current, selectedLetter: $event.selectedLetter, sort: $event.sort})"
                    />
                </template>
                <template v-if="menuNav.current == 'Generics' && accessAllNav">
                    <GenericListComponent
                        @set_generics="menuNavRedirect($event.value, {type: menuNav.current, selectedLetter: $event.selectedLetter, sort: $event.sort})"
                    />
                </template>
            </div>
            <SpinnerComponent v-else color="primary" size="64" />
        </DashboardLayoutComponent>
    </div>
</template>

<script>
import DashboardLayoutComponent from "@Layouts/dashboard/";
import {
    SectionListComponent,
    DiseaseListComponent,
    SpecialtyListComponent,
    BrandListComponent,
    GenericListComponent
} from "@Layouts/dashboard/components";
import { EmptyStateComponent } from "@CommonComponents";
import { ViewListIcon, ArrowLeftIcon } from "@heroicons/vue/outline";
import { onMounted } from "vue";
import { Tokens } from "@Utilities/enum";
import { NavbarComponent } from "@Layouts/dashboard/components";

import useSections from "@Functions/useSections.js";
import useMenuNav from "@Functions/useMenuNav.js";

export default {
    name: "InitialLandingModule",
    components: {
        DashboardLayoutComponent,
        ViewListIcon,
        ArrowLeftIcon,
        SectionListComponent,
        EmptyStateComponent,
        DiseaseListComponent,
        BrandListComponent,
        NavbarComponent,
        SpecialtyListComponent,
        GenericListComponent
    },
    setup() {
        const {
            sectionProps,
            onSectionClicked,
            onSetSections,
            onSetMetrics,
            onNavChanged,
            isLoading,
            onSetCurrentSidebar,
            arr,
            sectionLevelSelected,
            emptyStateProps,
            updateSectionId,
            sectionId,
            showBackButton,
            showList,
            isTablet,
            goBackBtnProps,
            store,
            userMetricLevel,
            accessAllNav
        } = useSections();

        const {
            menuNavRedirect,
            menuNav,
            onMenuNavTypeChange
        } = useMenuNav();

        onMounted(() => {
            store.dispatch("Cookies/onDeleteCookies", Tokens.MenuNav);
            store.dispatch("Cookies/onDeleteCookies", Tokens.Filters);
        });

        return {
            sectionProps,
            onSectionClicked,
            onSetSections,
            onSetMetrics,
            isLoading,
            onSetCurrentSidebar,
            arr,
            sectionLevelSelected,
            emptyStateProps,
            updateSectionId,
            sectionId,
            isTablet,
            showList,
            showBackButton,
            goBackBtnProps,
            onNavChanged,
            menuNav,
            onMenuNavTypeChange,
            menuNavRedirect,
            userMetricLevel,
            accessAllNav
        };
    },
};
</script>

<style lang="scss">
.initial-landing-module {
    .initial-landing {
        @apply grid grid-cols-7 gap-0 border border-gray-200 rounded-lg shadow-sm divide-gray-200 bg-white min-h-screen;
        align-content: start;
        .initial-landing {
            &__wrapper {
                @apply flex items-center col-span-12 p-3 border-b border-gray-200;
                max-height: 45px;
            }
            &__back-btn {
                @apply col-span-12 p-3 pb-0;
            }
            &__icon {
                @apply h-5 w-5 mr-2 text-gray-400;
            }
            &__title {
                @apply text-sm leading-5 font-semibold text-gray-500;
            }
            &__list {
                @apply p-3;
                &.empty-state-component {
                    @apply md:col-span-2;
                }
            }
        }
    }
    .section-metric {
        @apply grid-cols-6;
    }
    .spinner-component {
        @apply flex items-center justify-center;
        min-height: 67vh;
    }
}
</style>
